import React from "react";
import { t } from "../utils/i18n";

// Carte "Sorties" pour le module de recherche — vignette pleine largeur + titre + lieu + date,
// repris de PostCard.tsx (héros à fond perdu, badges catégorie/prix) mais allégé : pas de pile
// d'avatars ni de badge de places, une carte de recherche n'a qu'un rôle d'aperçu avant d'ouvrir
// la vraie fiche de la publication.
const COVER_FALLBACK = "linear-gradient(160deg, #0a0a0aCC 0%, #0a0a0a 100%)";

// "sam. 12 sept. à 09:00" — Intl produit déjà l'abréviation avec le point ("sam.", "sept.") en
// fr-FR, il suffit d'assembler date courte + heure avec le séparateur "à".
const formatEventDateTime = (dateStr: string, lang: string) => {
  const d = new Date(dateStr);
  const locale = lang === "en" ? "en-US" : lang;
  const datePart = d.toLocaleDateString(locale, { weekday: "short", day: "numeric", month: "short" });
  const timePart = d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  return lang === "en" ? `${datePart}, ${timePart}` : `${datePart} à ${timePart}`;
};

export default function SearchEventCard({ event, lang, onClick }: { event: any; lang: string; onClick: () => void }) {
  const isFree = event.is_free || Number(event.price) === 0;
  return (
    <div
      onClick={onClick}
      style={{
        height: 160, borderRadius: 16, overflow: "hidden", position: "relative", cursor: "pointer",
        background: event.cover_url ? `url(${event.cover_url}) center/cover` : COVER_FALLBACK,
        display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: 12, marginBottom: 12,
      }}
    >
      {event.category && (
        <div style={{ position: "absolute", top: 10, left: 10, backgroundColor: "rgba(0,0,0,0.6)", borderRadius: 20, padding: "4px 10px", color: "white", fontSize: 10.5, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" }}>
          {event.category}
        </div>
      )}
      <div style={{ position: "absolute", top: 10, right: 10, backgroundColor: isFree ? "#0a0a0a" : "rgba(0,0,0,0.6)", borderRadius: 20, padding: "4px 10px", color: "white", fontSize: 11.5, fontWeight: 700 }}>
        {isFree ? (t(lang, "price_free") || "Gratuit") : `${event.price}€`}
      </div>
      <div style={{ color: "white", textShadow: "0 2px 8px rgba(0,0,0,0.45)" }}>
        <div style={{ fontSize: 15.5, fontWeight: 800, marginBottom: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{event.title}</div>
        <div style={{ fontSize: 12.5, opacity: 0.9, display: "flex", flexWrap: "wrap", gap: 8 }}>
          {event.event_date && <span>{formatEventDateTime(event.event_date, lang)}</span>}
          {event.location_name && <span>· {event.location_name}</span>}
        </div>
      </div>
    </div>
  );
}
